
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FactoryIcon from '@mui/icons-material/Factory';
import InventoryIcon from '@mui/icons-material/Inventory';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import ApprovalIcon from '@mui/icons-material/Approval';
import AddTaskIcon from '@mui/icons-material/AddTask';

const Accounts = {
  id: '4',
  title: 'Order Mgmt',
  type: 'group',
  role: 'PHARMA_OMS_ACCOUNTS',
  children: [
    {
        id: 'mdapprovallist',
        title: 'My Approval List',
        type: 'item',
        url: '/',
        bottomMenu:'APPROVAL-LIST',
        icon: ApprovalIcon
    },
    {
      id: 'pharmaorder',
      title: 'Order List',
      type: 'item',
      url: '/',
      bottomMenu:'ORDERS',
      icon: ShoppingBagIcon
    },
    {
                id: 'orderapproval',
                title: 'Order Approval',
                type: 'item',
                url: '/',
                bottomMenu:'ORDER_APPROVAL',
                icon: AddTaskIcon
              },
    
  ]
};

export default Accounts;